export default "__VITE_ASSET__LIaJQOvp__"